import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { Route, RouterModule } from '@angular/router';
import {  
  NgbCollapseModule,
  NgbDateParserFormatter,
  NgbDropdownModule,
  NgbModule,
} from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DatePickerModule } from 'src/app/shared/date-picker/date-picker.module';
import { DateRangePickerModule } from 'src/app/shared/date-range-picker/date-range-picker.module';
import { SharedNewModule } from '../shared-new/shared-new.module';
import { SaleConsignorListComponent } from './sale-consignor-list/sale-consignor-list.component';
import { SaleGrantedComponent } from './sale-granted/sale-granted.component';
import { SaleHorseInternalNotePopupComponent } from './sale-horse-internal-note-popup/sale-horse-internal-note-popup.component';
import { SaleHorseListComponent } from './sale-horse-list/sale-horse-list.component';
import { SaleHorseScopeViewerPopupComponent } from './sale-horse-scope-viewer-popup/sale-horse-scope-viewer-popup.component';
import { SaleHorseXRayReportsPopupComponent } from './sale-horse-xray-reports-popup/sale-horse-xray-reports-popup.component';
import { SaleListComponent } from './sale-list/sale-list.component';
import { EmailInputComponent } from '../shared/email-input/email-input.component';
import { SaleMemberRequestPopupComponent } from './sale-member-request-popup/sale-member-request-popup.component';
import { SaleProfileComponent } from './sale-profile/sale-profile.component';
import { SaleRequestsComponent } from './sale-requests/sale-requests.component';
import { SaleSendEmailSmsPopupComponent } from './sale-send-email-sms-popup/sale-send-email-sms-popup.component';
import { SaleSettingComponent } from './sale-setting/sale-setting.component';

import { SaleSubmissionsPopupComponent } from './sale-submissions-popup/sale-submissions-popup.component';
import { EmailStudyDataModalComponent } from './email-study-data-modal/email-study-data-modal.component';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { StudiesComponentModule } from '../clinic-studies/edit-clinical-study/components/studies-components.module';
import { SharedDirectivesModule } from '../shared-new/directives/shared-directives.module';
import { DaterangepickerDirective } from '../shared/directives/daterangepicker.directive';
import { DateTimepickerDirective } from '../shared/directives/singledaterangepicker.directive';
import { DateParserFormatter } from '../utils/helper/date-parser-formatter';
import { DeadLinesPopupComponent } from './dead-lines-popup/dead-lines-popup.component';
import { SaleBreezeDateModalComponent } from './sale-breeze-date-modal/sale-breeze-date-modal.component';
import { SaleGrantedAllComponent } from './sale-granted-all/sale-granted-all.component';
import { SaleStudyFilesPopupComponent } from './sale-study-files-popup/sale-study-files-popup.component';
import { StudyFilesComponent } from './sale-study-files-popup/study-files/study-files.component';
import { SaleSubmissionsComponent } from './sale-submissions/sale-submissions.component';
import { SaleTermsConditionPopupComponent } from './sale-terms-condition-popup/sale-terms-condition-popup.component';
import { SaleVetListComponent } from './sale-vet-list/sale-vet-list.component';
import { SaleHorseStatusModalComponent } from './sale-horse-status-modal/sale-horse-status-modal.component';
import { SaleMemberAccessPopupComponent } from './sale-member-access-popup/sale-member-access-popup.component';
import { SaleConsignorContactsPopupComponent } from './sale-consignor-contacts/sale-consignor-contacts-popup.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { SaleHorseRepoContactListComponent } from './sale-horse-repo-contact-list/sale-horse-repo-contact-list.component';
import { SaleHorseRepoContactEditComponent } from './sale-horse-repo-contact-edit/sale-horse-repo-contact-edit.component';
import { SaleMediaConversionLogModalComponent } from './sale-media-conversion-log-modal/sale-media-conversion-log-modal.component';
import { RepocontactEditComponent } from '../repo-business/repocontact-edit/repocontact-edit.component';
import { RepoBusinessModule } from '../repo-business/repo-business.module';
import { SearchDropDownModule } from '../shared/search-dropdown/search-dropdown.module';
import { NotificationTemplateModule } from '../shared/notification-template/notification-template.module';
import { SearchBoxModule } from '../shared/search-box/search-box.module';

const routes: Route[] = [
  {
    path: '',
    component: SaleProfileComponent,
  },
];
@NgModule({
  declarations: [
    DaterangepickerDirective,
    DateTimepickerDirective,
    SaleListComponent,
    SaleTermsConditionPopupComponent,
    SaleHorseInternalNotePopupComponent,
    SaleHorseScopeViewerPopupComponent,
    SaleHorseXRayReportsPopupComponent,
    SaleProfileComponent,
    EmailStudyDataModalComponent,
    SaleHorseListComponent,
    SaleConsignorListComponent,
    SaleVetListComponent,
    SaleSettingComponent,
    SaleGrantedComponent,
    SaleGrantedAllComponent,
    SaleSendEmailSmsPopupComponent,
    SaleSubmissionsComponent,
    SaleRequestsComponent,
    SaleMemberRequestPopupComponent,
    SaleStudyFilesPopupComponent,
    
    SaleSubmissionsPopupComponent,
    DeadLinesPopupComponent,
    SaleBreezeDateModalComponent,
    SaleHorseStatusModalComponent,
    SaleMemberAccessPopupComponent,
    SaleConsignorContactsPopupComponent,
    SaleHorseRepoContactListComponent,
    SaleHorseRepoContactEditComponent,
    SaleMediaConversionLogModalComponent,
  ],
  providers: [
    DateParserFormatter, // Provide CustomDateParserFormatter here
    {
      provide: NgbDateParserFormatter,
      useExisting: DateParserFormatter, // Use the existing instance
    },

    StudyFilesComponent,
  ],
  imports: [
    CommonModule,
    SharedNewModule,
    RouterModule.forChild(routes),
    MatTableModule,
    MatSortModule,
    MatTabsModule,
    NgbCollapseModule,
    NgbModule,
    NgbDropdownModule,
    InfiniteScrollModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    DatePickerModule,
    DateRangePickerModule,
    MatRadioModule,
    StudiesComponentModule,
    EmailInputComponent,
    RepoBusinessModule,
    SharedDirectivesModule,
    MatSelectModule,
    NgxIntlTelInputModule,
    SearchDropDownModule,
    SearchBoxModule,
    NotificationTemplateModule
  ],
  exports: [SaleMemberAccessPopupComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SalesModule { }

